import axios from "axios";
import { getAuthToken, migrateLegacyToken } from "./authStorage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// One-time best-effort lift of any legacy localStorage token into the new
// sessionStorage-backed store. Safe to call repeatedly.
if (typeof window !== "undefined") {
    migrateLegacyToken();
}

api.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const PublicAPI = {
    createInquiry: (data) => api.post("/inquiries", data).then((r) => r.data),
    createPrintInquiry: (data) => api.post("/print-inquiries", data).then((r) => r.data),
    createMentoring: (data) => api.post("/mentoring-applications", data).then((r) => r.data),
    listJournal: () => api.get("/journal").then((r) => r.data),
    getJournal: (slug) => api.get(`/journal/${slug}`).then((r) => r.data),
};

export const AdminAPI = {
    login: (email, password) => api.post("/admin/login", { email, password }).then((r) => r.data),
    me: () => api.get("/admin/me").then((r) => r.data),
    listInquiries: () => api.get("/admin/inquiries").then((r) => r.data),
    updateInquiry: (id, status) => api.patch(`/admin/inquiries/${id}`, { status }).then((r) => r.data),
    listPrintInquiries: () => api.get("/admin/print-inquiries").then((r) => r.data),
    listMentoring: () => api.get("/admin/mentoring-applications").then((r) => r.data),
    listJournal: () => api.get("/admin/journal").then((r) => r.data),
    createJournal: (data) => api.post("/admin/journal", data).then((r) => r.data),
    updateJournal: (id, data) => api.put(`/admin/journal/${id}`, data).then((r) => r.data),
    deleteJournal: (id) => api.delete(`/admin/journal/${id}`).then((r) => r.data),
};
